module.exports = __webpack_public_path__ + "static/media/leonardo.ba5561ea.gif";